import { createAction, props } from '@ngrx/store';

export const setLanguage = createAction(
    '[Language] setLanguage',
    props<{ language: string }>()
);
